export default {
  namespaced: false,
  state: {
    scroll: true,
    theme: 'darkTheme',
    showAnalytics: true,
  },
  mutations: {
    SET_SCROLL(state, payload) {
      state.scroll = payload
      for (const className of ['tw-size-full', 'tw-relative', 'tw-overflow-hidden']) {
        document.body.classList.toggle(className, !payload)
      }
    },
    SET_THEME(state, payload) {
      document.documentElement.className = payload
      localStorage.theme = payload
      state.theme = payload
    },
    SET_SHOWANALYTICS(state, payload) {
      state.showAnalytics = payload
    },
  },
  getters: {
    theme(state) {
      return state.theme
    },
  },
}
